<p-select
  class="app-lenguage-switcher"
  [options]="lenguages"
  [(ngModel)]="selectedLanguage"
  optionLabel="label"

  (onChange)="switchLanguage($event)"
  [styleClass]="ownstyle || (btnlabel ? '!border-neutral-300 !bg-(-p-primary-500) !rounded-lg !shadow-2xs hover:!border-neutral-400 transition-all text-sm w-auto h-10' : '!border-neutral-300 !bg-(-p-primary-500) !rounded-lg !shadow-2xs hover:!border-neutral-400 transition-all text-sm w-25 h-10')"
  appendTo="body"
>
  <ng-template pTemplate="selectedItem">
    <div class="flex items-center text-center justify-center gap-2" *ngIf="selectedLanguage">
      <img
        alt="flag"
        [src]="'images/flags/flag_' + selectedLanguage.value + '.png'"
        class="h-4 w-auto object-contain rounded-xs shadow-2xs border border-neutral-200"
      />
      <span *ngIf="btnlabel" class="header-btn-label whitespace-nowrap text-sm">{{ btnlabel | translate }}</span>
            <i class="pi pi-language"></i>
    </div>
  </ng-template>

  <ng-template let-flags pTemplate="item">
    <div class="flex justify-center items-center gap-2.5 py-1 px-1" [pTooltip]="flags.label" tooltipPosition="left">
      <img
        alt="flag"
        [src]="'images/flags/flag_' + flags.value + '.png'"
        class="h-4 w-auto object-contain rounded-xs shadow-2xs border border-neutral-200"
      />
      <span class="text-xs font-medium text-neutral-700">{{ flags.label }}</span>
    </div>
  </ng-template>
</p-select>
